import { ValidationError } from 'yup';
function toChangesetPath(path) {
  return path?.replace(/\[(\d+)\]/g, '.$1') ?? '';
}
export async function validateAndMapErrors(schema, dto) {
  try {
    await schema.validate(dto, {
      abortEarly: false
    });
  } catch (e) {
    if (e instanceof ValidationError) {
      return e.inner.map(e => {
        return {
          message: e.message,
          params: e.params,
          key: toChangesetPath(e.path),
          value: e.value,
          originalValue: ''
        };
      });
    }
  }
  return [];
}
export function validateOne(schema) {
  return async (value, field, draft) => {
    try {
      // validateAt seems to behave weirdly with .when conditions. Using validate instead.
      await schema.validate(draft, {
        abortEarly: false
      });
    } catch (e) {
      if (e instanceof ValidationError) {
        const fieldError = e.inner.find(inner => toChangesetPath(inner.path) === field);
        if (!fieldError) {
          return undefined;
        }
        return {
          message: fieldError.message,
          params: fieldError.params,
          key: toChangesetPath(fieldError.path),
          value: fieldError.value,
          originalValue: ''
        };
      }
    }
    return undefined;
  };
}